// import Swiper bundle with all modules installed, including Autoplay for autoplay functionality
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

// Load GSAP UMD bundle as raw code and execute it
import gsapRaw from 'raw-loader!gsap/dist/all.js';
import Lenis from 'lenis';

// Execute the GSAP code in global scope to avoid webpack module wrapping
(0, eval)(gsapRaw);

// Now access GSAP from window where the UMD build placed it
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;
const Flip = window.Flip;

// Register plugins AFTER DOM is ready (Flip needs document.body)
if (document.body) {
  // DOM already ready, register immediately
  registerGSAPPlugins();
} else {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', registerGSAPPlugins);
}

function registerGSAPPlugins() {
  if (gsap && ScrollTrigger && Flip) {
    // Manually register Flip with GSAP core first (it needs document.body)
    if (typeof Flip.register === 'function') {
      Flip.register(gsap);
    }
    
    // Then register via standard method
    gsap.registerPlugin(ScrollTrigger, Flip);
  }
}

document.addEventListener("scroll", () => {
    if (window.scrollY > 20) {
        document.documentElement.classList.add("scrolling");
    } else {
        document.documentElement.classList.remove("scrolling");
    }
});

function heroVideo() {
  const heroVideo = document.querySelector('.hero-video');
  if (!heroVideo) return;
  let desktopVideo = heroVideo.dataset.desktop;
  let mobileVideo = heroVideo.dataset.mobile; 
  if (heroVideo) {
    if (window.innerWidth > 768) {
      heroVideo.src = desktopVideo;
    } else {
      heroVideo.src = mobileVideo;
    }
    heroVideo.play();
  }
}

function mobileMenu() {
  function onToggleNavigationInteraction(callback) {
    const el = document.getElementById('toggle-navigation');
    if (!el) return;

    let touched = false;

    el.addEventListener('touchstart', function (e) {
    touched = true;
    callback(e);
    }, { passive: true });

    el.addEventListener('click', function (e) {
    if (touched) {
      touched = false;
      return;
    }
    callback(e);
    }, { passive: true });
  }

  function submenuToggleInit() {
    document.querySelectorAll('.submenu-toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      const parentLi = btn.closest('li');
      if (parentLi) {
      parentLi.classList.toggle('open');
      }
    }, { passive: true });
    });
  }

  function closeMobileMenu() {
    const closer = document.querySelector('.mobile-menu .closer');
    if (!closer) return;
    closer.addEventListener('click', function(e) {
      // console.log('Mobile menu close button clicked');
      const html = document.documentElement;
      html.classList.remove('mobile-menu-open');
      e.preventDefault();
    }, { passive: true });
  }

  onToggleNavigationInteraction(function(e) {
    // console.log('Navigation toggle interaction detected');
    const html = document.documentElement;
    html.classList.toggle('mobile-menu-open');
  });

  submenuToggleInit();
  closeMobileMenu();
}

function ourExpertise() {
  if(window.innerWidth < 1024) {
    return;
  }


  const ourExpertise = document.querySelector('.our-expertise');
  
  if (!ourExpertise) return;

  const title = ourExpertise.querySelectorAll('h2');
  if (!title || title.length === 0) return;
  const stats = ourExpertise.querySelectorAll('.stat');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ourExpertise,
      start: "top bottom",
      end: "bottom  75%",
      scrub: true,
      toggleActions: "play none none reverse",
      // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
    }
  });
  tl.fromTo(title, { opacity:1, x: -100}, { opacity:1, x: 0, duration: 0.6, ease: 'power2.out' });
  let stagger = 0.1;
  stats.forEach((stat, key) => {
    tl.fromTo(stat, { opacity:0, y: 0}, { opacity:1, y: 0, duration: 0.3, ease: 'power2.out'},0+stagger);
    stagger += 0.05;
  });
}

let ourProcessScrollTriggers = [];
let ourProcessResizeTimeout;
let ourProcessResizeListenerAttached = false;

function resetOurProcessState() {
  if (ourProcessScrollTriggers.length) {
    ourProcessScrollTriggers.forEach((trigger) => trigger.kill());
    ourProcessScrollTriggers = [];
  }

  const ourProcessRow = document.querySelector('.our-process-row');
  if (!ourProcessRow) return;

  const textInners = ourProcessRow.querySelectorAll('.process-step .text-inner');
  textInners.forEach((inner) => {
    gsap.set(inner, { clearProps: 'all' });
    inner.classList.remove('centered', 'exiting');
  });
}

function ourProcess() {
  resetOurProcessState();

  // check window width
  if(window.innerWidth < 1024) {
    return;
  }
  

  const ourProcess = document.querySelector('.our-process-row');
  

  if (!ourProcess) return;
  
  function animateTitle() {
    const title = ourProcess.querySelectorAll('h2');
    const title2 = ourProcess.querySelectorAll('h2 em');

    if (!title || title.length === 0) return;
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ourProcess,
        start: "top bottom",
        end: "top top",
        scrub: true,
        toggleActions: "play none none reverse",
        // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
      }
    });
    tl.fromTo(title, { x: -100}, { x: 0, duration: 0.6 });
    tl.fromTo(title2, { x: -50}, { x: 0, duration: 0.6 },'<'); 
  }
  animateTitle();

  // Get all process steps
  const processSteps = ourProcess.querySelectorAll('.process-step');
  // first inner is fully visible, the rest are hidden
  processSteps.forEach((step, key) => {
    const inner = step.querySelector('.text-inner');
    inner.classList.remove('centered', 'exiting');
    
    // Capture original position before any ScrollTrigger modifications
    const originalRect = inner.getBoundingClientRect();
    const originalLeft = originalRect.left;
    
    if(key === 0) {
      gsap.set(inner, {
        opacity: 1
      });
    } else {
      gsap.set(inner, {
        opacity: 0
      });
    }
    const trigger = ScrollTrigger.create({
       trigger: step,
       start: 'top 50%', // Start animation when top of step reaches 25% of viewport
       end: 'bottom 50%', // End when bottom of step reaches 75% of viewport
       markers: false,
       scrub: true, 
       onUpdate: (self) => {
         // Handle sticky behavior manually
         if (self.progress > 0 && self.progress < 1) {
           // Check if element has reached center of viewport
           const rect = inner.getBoundingClientRect();
           const elementCenter = rect.top + (rect.height / 2);
           const viewportCenter = window.innerHeight / 2;
           const isAtCenter = Math.abs(elementCenter - viewportCenter) < 50; // 50px tolerance
           
           // For the first element, only animate when it reaches center and hasn't been centered yet
           if (key === 0 && isAtCenter && !inner.classList.contains('centered') && !inner.classList.contains('exiting')) {
             // Mark as centered to prevent re-animation
             inner.classList.add('centered');
             
             // Set fixed positioning at current location
             gsap.set(inner, {
               position: 'fixed',
               top: rect.top + 'px',
               left: rect.left + 'px',
               zIndex: 10
             });
             
             // Then smoothly animate to center
             gsap.to(inner, {
               top: '50vh',
               left: originalLeft + 'px',
               transform: 'translateY(-50%)',
               duration: 0.5,
               ease: 'power2.out'
             });
           } else if (key === 0 && !isAtCenter && inner.classList.contains('centered')) {
             // Element was centered but is now moving away - mark as exiting
             inner.classList.add('exiting');
             // Reset to relative positioning immediately when exiting
             gsap.set(inner, {
               position: 'relative',
               top: 'auto',
               left: 'auto',
               transform: 'none',
               zIndex: 'auto'
             });
           } else if (key === 0 && !isAtCenter && !inner.classList.contains('centered')) {
             // Element hasn't reached center yet, let it scroll naturally
             // Do nothing - let it scroll in naturally
           } else if (key === 0 && inner.classList.contains('exiting')) {
             // First element is exiting - keep it relative, do nothing
             // Do nothing - let it scroll naturally
           } else {
             // For other elements or after transition, use instant positioning
             gsap.set(inner, {
               position: 'fixed',
               top: '50vh',
               left: originalLeft + 'px',
               transform: 'translateY(-50%)',
               zIndex: 10
             });
           }
         }
         // Don't reset positioning here - let the fade out callbacks handle it
       },
       onEnter: () => {
         gsap.to(inner, {
           opacity: 1,
           duration: 0.5,
           ease: 'power2.out',
           delay: 0.5
         });
       },
       onLeave: () => {
         gsap.to(inner, {
           opacity: 0,
           duration: 0.5,
           ease: 'power2.out',
           onComplete: () => {
             // Reset positioning after fade out completes
             gsap.set(inner, {
               position: 'relative',
               top: 'auto',
               left: 'auto',
               transform: 'none',
               zIndex: 'auto'
             });
           }
         });
       },
       onEnterBack: () => {
         gsap.to(inner, {
           opacity: 1,
           duration: 0.5,
           ease: 'power2.out'
         });
       },
       onLeaveBack: () => {
         // For first element, if it's exiting, don't fade out - just clean up
         if (key === 0 && inner.classList.contains('exiting')) {
           // Reset positioning immediately
           gsap.set(inner, {
             position: 'relative',
             top: 'auto',
             left: 'auto',
             transform: 'none',
             zIndex: 'auto'
           });
           
           // Remove classes to allow re-animation
           inner.classList.remove('centered', 'exiting');
         } else {
           // For other elements, fade out normally
           gsap.to(inner, {
             opacity: 0,
             duration: 0.5,
             ease: 'power2.out',
             onComplete: () => {
               // Reset positioning after fade out completes
               gsap.set(inner, {
                 position: 'relative',
                 top: 'auto',
                 left: 'auto',
                 transform: 'none',
                 zIndex: 'auto'
               });
               
               // For first element, remove classes to allow re-animation
               if (key === 0) {
                 inner.classList.remove('centered', 'exiting');
               }
             }
           });
         }
       }
     });
     ourProcessScrollTriggers.push(trigger);
  });

  ScrollTrigger.refresh();
}

if (!ourProcessResizeListenerAttached) {
  ourProcessResizeListenerAttached = true;
  const handleOurProcessResize = () => {
    clearTimeout(ourProcessResizeTimeout);
    ourProcessResizeTimeout = setTimeout(() => {
      ourProcess();
    }, 200);
  };

  window.addEventListener('resize', handleOurProcessResize);
  window.addEventListener('orientationchange', handleOurProcessResize);
}

function successStories() {
  if(window.innerWidth < 1024) {
    return;
  }

  const portfolioStories = document.querySelectorAll('.portfolio-story');
  
  if (portfolioStories.length === 0) return;

  // the story marked active on page load never runs the click flow below
  document.querySelector('.portfolio-story.active')?.classList.add('text-revealed');

  portfolioStories.forEach((story) => {
    story.addEventListener('click', (e) => {
      // Already active: let the card's link navigate through as normal
      if (story.classList.contains('active')) return;

      // Not active yet: preview/expand it instead of following the link
      e.preventDefault();

      // Get all elements to animate (parents and children)
      const elementsToAnimate = [
        ...portfolioStories,
        ...document.querySelectorAll('.portfolio-story .content'),
        ...document.querySelectorAll('.portfolio-story h3'),
        ...document.querySelectorAll('.portfolio-story picture'),
        ...document.querySelectorAll('.portfolio-story .images'),
      ];

      // Capture the current state of all elements before making changes
      const state = Flip.getState(elementsToAnimate);

      // Remove active class from all stories
      portfolioStories.forEach((s) => {
        s.classList.remove('active');
        s.classList.remove('text-revealed');
      });

      // Add active class to clicked story
      story.classList.add('active');

      // Animate from the old state to the new state
      Flip.from(state, {
        duration: 0.6,
        ease: 'power2.inOut',
        absolute: false,
        nested: true,
        fade: true,
        // fade in the description/read-more only once the flip has settled
        onComplete: () => {
          story.classList.add('text-revealed');
        },
      });
    });
  });

  // add event listeners to the story buttons
  const prevStory = document.querySelector('.prev-story');
  const nextStory = document.querySelector('.next-story');
  prevStory.addEventListener('click', () => {
    console.log('Previous story clicked');
    // click on the previous story
    const previousStory = document.querySelector('.portfolio-story.active').previousElementSibling;
    if (previousStory) {
      previousStory.click();
    }
  });
  nextStory.addEventListener('click', () => {
    console.log('Next story clicked');
    // click on the next story
    const nextStory = document.querySelector('.portfolio-story.active').nextElementSibling;
    if (nextStory) {
      nextStory.click();
    }
  });
}


function services() {
  if(window.innerWidth < 1024) {
    return;
  }
  // On scroll down, when it reaches the .home-content section, it fades in each picture element with a stagger effect
  const services = document.querySelectorAll('.services-row');

  if (!services) return;
  services.forEach((service) => {
    const title = service.querySelectorAll('h2');
    const title2 = service.querySelectorAll('h2 em');
    if (!title || title.length === 0) return;
    const pictureFrame = service.querySelectorAll('.service-box');
    const picture = service.querySelectorAll('picture img');
    if (!picture || picture.length === 0) return;
  
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: service,
        start: "top bottom",
        end: "center 20%",
        scrub: true,
        toggleActions: "play none none reverse",
        // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
      }
    });
    tl.fromTo(title, { x: -100}, { x: 0, duration: 0.6 });
    tl.fromTo(title2, { x: -50}, { x: 0, duration: 0.6 },'<'); 
    // Commented out because the client doesn't like fun.
    // tl.fromTo(pictureFrame, { scale: 0.5}, { scale: 1, duration: 0.6 },'<'); 
    // tl.fromTo(picture, { scale: 2}, { scale: 1, duration: 0.6 },'<'); 
  });
}


function whoWeWorkWith() {
  if(window.innerWidth < 1024) {
    return;
  }
  // On scroll down, when it reaches the .home-content section, it fades in each picture element with a stagger effect
  const homeContent = document.querySelector('.who-we-work-with-row');
  if (!homeContent) return;
  const title = homeContent.querySelectorAll('h2');
  if (!title || title.length === 0) return;
  const picture2 = homeContent.querySelectorAll('picture:nth-child(even)');
  if (!picture2 || picture2.length === 0) return;
  
  
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: homeContent,
      start: "top bottom",
      end: "bottom -20%",
      scrub: true,
      toggleActions: "play none none reverse",
      // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
    }
  });
  tl.fromTo(title, { y: 300}, { y: -200, duration: 0.6 });
  tl.fromTo(picture2, { y: 400}, { y: -200, duration: 0.6 },'<'); 
}

function ourhistory() {
  if(window.innerWidth < 1024) {
    return;
  }
  const ourHistory = document.querySelector('.our-history');
  if (!ourHistory) {
    // console.log('ourHistory: .our-history not found');
    return;
  }
  
  const timeline = ourHistory.querySelector('.timeline');
  if (!timeline) {
    // console.log('ourHistory: .timeline not found');
    return;
  }

  const timelineItemsContainer = timeline.querySelector('.timeline-items');
  if (!timelineItemsContainer) {
    // console.log('ourHistory: .timeline-items container not found');
    return;
  }

  const timelineItems = timelineItemsContainer.querySelectorAll('.timeline-item');
  if (!timelineItems || timelineItems.length === 0) {
    // console.log('ourHistory: .timeline-item not found');
    return;
  }

  const timelineNav = document.querySelector('.timeline-nav');
  if (!timelineNav) {
    // console.log('ourHistory: .timeline-nav not found - timeline navigation disabled');
    // Continue without nav functionality
  }
  
  const timelineNavItems = timelineNav ? timelineNav.querySelectorAll('.timeline-nav-item') : [];

  // Convert NodeList to Array for indexOf
  const timelineItemsArray = Array.from(timelineItems);

  // Only add scroll detection if timeline nav exists
  if (timelineNav && timelineNavItems.length > 0) {
    // As viewport is scrolled, it detects which timeline item (.timeline-item) is in view and adds the active class to the corresponding timeline nav item
    document.addEventListener('scroll', () => {
      timelineItems.forEach((item) => {
        if (!item) return; // Safety check
        const rect = item.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 200) {
          // Get the index of the timeline item
          const index = timelineItemsArray.indexOf(item);
          // Find the timeline nav item with the same index
          const timelineNavItem = timelineNavItems[index];
          if (!timelineNavItem) return;
          // Remove the active class from all timeline nav items
          timelineNavItems.forEach((navItem) => {
            navItem.classList.remove('active');
          });
          // Add the active class to the timeline nav item
          timelineNavItem.classList.add('active');
        }
      });
    });
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ourHistory,
      start: "top bottom",
      end: "center 20%",
      scrub: true,
      toggleActions: "play none none reverse",
      // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
    }
  });
  let title = ourHistory.querySelectorAll('h2');
  let title2 = ourHistory.querySelectorAll('h2 em');

  tl.fromTo(title, { x: -100}, { x: 0, duration: 0.6 });
  tl.fromTo(title2, { x: -50}, { x: 0, duration: 0.6 },'<'); 

  timelineItems.forEach((item) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        toggleActions: "play none none reverse",
        // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
      }
    });
    let title = item.querySelectorAll('h3');
    let content = item.querySelectorAll('.content');
    let image = item.querySelectorAll('.image-2');
    let stat = item.querySelectorAll('.stat');
    tl.fromTo(title, { y: -200}, { y: 0, duration: 0.6 },'<');
    tl.fromTo(content, { y: -200}, { y: 0, duration: 0.6 },'<');
    tl.fromTo(image, { y: -300}, { y: 0, duration: 0.6 },'<');
    tl.fromTo(stat, { y: -250}, { y: 0, duration: 0.6 },'<');
  });

  // When click on the timeline nav item, it scrolls to the corresponding timeline item accounting for header height
  timelineNavItems.forEach((navItem, index) => {
    navItem.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Get the target ID from the href attribute
      const href = navItem.getAttribute('href');
      const targetId = href ? href.replace('#', '') : null;
      const timelineItem = targetId ? document.getElementById(targetId) : timelineItems[index];
      
      if (timelineItem) {
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        const elementPosition = timelineItem.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight - 20; // 20px extra padding
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        setTimeout(() => {
          // Update active state
          timelineNavItems.forEach((item) => item.classList.remove('active'));
          navItem.classList.add('active');
        }, 1000);
      }
    });
  });

}

function ourFounders() {
  if(window.innerWidth < 1024) {
    return;
  }
  let ourFounders = document.querySelector('.our-founders');
  if (!ourFounders) return;

  const title = ourFounders.querySelectorAll('h2');
  if (!title || title.length === 0) return;
  const founders = ourFounders.querySelectorAll('.founder');
  if (!founders || founders.length === 0) return;
    
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ourFounders,
      start: "top bottom",
      end: "center 20%",
      scrub: true,
      toggleActions: "play none none reverse",
      // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
    }
  });

  tl.fromTo(title, { x: -100}, { x: 0, duration: 0.6 });
  
  var offset = 0.2;
  var yOffset = 0;
  founders.forEach((founder) => {
    tl.fromTo(founder, { y: 200+yOffset}, { y: yOffset, duration: 0.6},offset);
    // offset += 0.2;
    // yOffset += 100;
  });

}

function ourExperience() {
  if(window.innerWidth < 1024) {
    return;
  }

  const ourExperience = document.querySelector('.our-experience');
  if (!ourExperience) return;
  const title = ourExperience.querySelectorAll('h2');
  const ups = ourExperience.querySelectorAll('.item');
  if (!ups || ups.length === 0) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ourExperience,
      start: "top bottom",
      end: "center 20%",
      scrub: true,
      toggleActions: "play none none reverse",
      // markers: {startColor:"green", endColor:"red", fontSize:"12px"}
    }
  });
  tl.fromTo(title, { x: -100}, { x: 0, duration: 0.6 });
  var offset = 0.2;
  ups.forEach((up) => {
    tl.fromTo(up, { opacity: 0}, { opacity: 1, duration: 0.6},offset);
    offset += 0.2;
  });
}

function childPages() {

    const childPageLinks = document.querySelectorAll('.child-page-link');
    const container = document.querySelector('.ajax-content');
    if (!container) return;
    if (typeof ajaxData === 'undefined') {
      console.error('ajaxData is not defined');
      return;
    }
    
    childPageLinks.forEach((childPageLink) => {
      childPageLink.addEventListener('click', (e) => {
      e.preventDefault();
      const childPageId = childPageLink.dataset.id;
      if (!childPageId) return;
      
      console.log('Loading child page with ID/slug:', childPageId);
      
      const formData = new FormData();
      formData.append('action', 'get_child_page_content');
      formData.append('child_page_id', childPageId);
      
      fetch(ajaxData.ajaxUrl, {
        method: 'POST',
        body: formData
      }).then((response) => {
        return response.json();
      }).then((data) => {
        if (!container) return;
        
        // Check for error response from server
        if (data.error) {
          console.error('Server error:', data.message);
          return;
        }
        
        // remove the .active class from all child page links
        childPageLinks.forEach((childPageLink) => {
          childPageLink.classList.remove('active');
        });
        // add the .active class to the clicked child page link
        childPageLink.classList.add('active');
        // fade out the container
        gsap.to(container, { opacity: 0, duration: 0.6, onComplete: () => {
          container.innerHTML = data.content;
          // fade in the container
          gsap.to(container, { opacity: 1, duration: 0.6 });
          // update the meta title
          document.title = data.title;
          // update the history 
          history.pushState({ page: data.title }, data.title, data.url);

          loadAllTheThings();

          // scroll to the content of the tab accounting for header height
          const header = document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 0;
          const elementPosition = document.getElementById('child-pages-container').getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight - 20; // 20px extra padding

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          console.log('scrolled to the content of the tab');
        } });
      }).catch((error) => {
        console.error('Error fetching child page content:', error);
      });
    });  
    });

  // Check if there is a query string and it's not empty
  const query = window.location.search;
  if (query && query.length > 1) {
    // Extract the tab identifier (removes '?' and '=' and gets the value)
    const tabParam = query.split('=').pop();
    if (tabParam) {
      console.log('tabParam', tabParam);
      // Try to find a child page link with data-id matching the query param accounting for trailing slash or not
      const tabToActivate = Array.from(childPageLinks).find(link => link.dataset.id === tabParam || link.dataset.id === tabParam.replace('/', ''));
      
      if (tabToActivate) {
        console.log('Activating tab:', tabParam);
        tabToActivate.click();
        
      } else {
        console.warn('No matching tab found for:', tabParam);
      }
    }
  }
}

function contentWithWysiwyg() {
  if(window.innerWidth < 1024) {
    return;
  }
  const contentWithWysiwygs = document.querySelectorAll('.wysiwyg_50_image_50,.key-features,.single-image,.wysiwyg-image-bottom-image-right');
  if (!contentWithWysiwygs || contentWithWysiwygs.length === 0) return;

  contentWithWysiwygs.forEach((contentWithWysiwyg) => {
    const picture = contentWithWysiwyg.querySelectorAll('picture');
    const image = contentWithWysiwyg.querySelectorAll('img');
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: contentWithWysiwyg,
        start: "top bottom",
        end: "center center",
        scrub: true,
        toggleActions: "play none none reverse",
      }
    });
    tl.fromTo(picture, { scale: 0.5}, { scale: 1, duration: 0.6 });
    tl.fromTo(image, { scale: 2}, { scale: 1, duration: 0.6 },'<');
  });
}

function videoRow() {
  if(window.innerWidth < 1024) {
    return;
  }
  const videoRows = document.querySelectorAll('.video-row');
  if (!videoRows || videoRows.length === 0) return;
  videoRows.forEach((videoRow) => {
    // deopending on viewport width, get the video element data-desktop or data-mobile
    let video;
    video = videoRow.querySelector('video');
    if (!video) return;
    // set the video source depending on viewport width
    if (window.innerWidth > 1024) {
      video.src = video.dataset.desktop;
    } else {
      video.src = video.dataset.mobile;
    }

    // scale in the video as it comes into view,  play it, unmute it and increase the volume
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: videoRow,
        start: "top bottom",
        end: "center center",
        scrub: true,
        toggleActions: "play none none reverse",
      }
    });
    tl.fromTo(video, {  volume: 0, scale: 0.5}, { volume: 1, scale: 1, duration: 0.6, onStart: () => {
      video.play();
    } });
  });
}

function relatedPosts() {
  // related posts swiper
  const relatedPostsSwiper = document.querySelector('.related-posts-swiper');
  if (!relatedPostsSwiper) return;
  new Swiper(relatedPostsSwiper, {
    slidesPerView: 1,
    spaceBetween: 14,
    navigation: {
      nextEl: '.related-posts-swiper-next',
      prevEl: '.related-posts-swiper-prev',
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
  });
}

function ourPartners() {
  const ourPartnersSwiper = document.querySelector('.our-partners-swiper');
  if (!ourPartnersSwiper) return;
  new Swiper(ourPartnersSwiper, {
    slidesPerView: 1,
    spaceBetween: 80,
    watchOverflow: true,
    loop: true,
    freeMode: true,
    speed: 4000,
    breakpoints: {
      768: {
        slidesPerView: 3, 
      },
      1024: {
        slidesPerView: 5,
      },
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
}

function testimonialsSwiper() {
  const testimonialsSwipers = document.querySelectorAll('.testimonials-swiper');
  if (!testimonialsSwipers || testimonialsSwipers.length === 0) return;
  testimonialsSwipers.forEach((testimonialsSwiperEl) => {
    // scope nav buttons to this instance's own row so multiple carousels on one page don't share buttons
    const row = testimonialsSwiperEl.closest('.testimonials-row');
    new Swiper(testimonialsSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      loop: true,
      navigation: {
        nextEl: row ? row.querySelector('.testimonials-swiper-next') : '.testimonials-swiper-next',
        prevEl: row ? row.querySelector('.testimonials-swiper-prev') : '.testimonials-swiper-prev',
      },
    });
  });
}

function childArrows() {
  const childArrows = document.querySelectorAll('.child-arrow-link');
  if (!childArrows || childArrows.length === 0) return;
  childArrows.forEach((childArrow) => {
    childArrow.addEventListener('click', (e) => {
      e.preventDefault();
      const activeChildPageLink = document.querySelector('.child-pages-nav-container .child-page-link.active');
      // If the clicked child arrow is the next child arrow, find the active child page link in ".child-pages-nav-container" and click the next one if it exists
      if (activeChildPageLink) {
        
        // If the clicked child arrow is the previous child arrow, find the active child page link in ".child-pages-nav-container" and click the previous one if it exists
        if (childArrow.classList.contains('prev-child-arrow')) {
          console.log('previous child arrow clicked');
          const previousChildPageLink = activeChildPageLink.previousElementSibling;
          if (previousChildPageLink) {
            previousChildPageLink.click();
          } else {
            // loop back to the last child page link
            const lastChildPageLink = document.querySelector('.child-pages-nav-container .child-page-link:last-child');
            if (lastChildPageLink) {
              lastChildPageLink.click();
            }
          }
        } else {
          console.log('next child arrow clicked');
          const nextChildPageLink = activeChildPageLink.nextElementSibling;
            if (nextChildPageLink) {
              nextChildPageLink.click();
            } else {
              // loop back to the first child page link
              const firstChildPageLink = document.querySelector('.child-pages-nav-container .child-page-link:first-child');
              if (firstChildPageLink) {
                firstChildPageLink.click();
              }
            }
          }
        }
    });
  });
}
// Function to initialize/re-initialize all animations and interactions
function loadAllTheThings() {
  // Refresh ScrollTrigger instances
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  } 
  
  heroVideo();
  ourProcess();
  successStories();
  whoWeWorkWith();
  services();
  ourExpertise();
  ourExperience();
  ourhistory();
  ourFounders();
  contentWithWysiwyg();
  videoRow();
  relatedPosts();
  ourPartners();
  testimonialsSwiper();
  childArrows();
  // preLoadLink();
}

// Ensure the code runs after the window has fully loaded
window.onload = () => {

  const lenis = new Lenis();

  lenis.on('scroll', (scroll) => {
    if (Math.abs(scroll.deltaX) > Math.abs(scroll.deltaY)) {
      // Horizontal scroll detected
      // Calculate how much to adjust the vertical scroll
      const verticalAdjustment = scroll.deltaX * -1; // or any factor you want

      // Update Lenis's vertical scroll position
      lenis.scrollTo(lenis.scroll.y + verticalAdjustment, {
        immediate: true,
      });

      // Prevent default horizontal scrolling
      // event.preventDefault(); //Not directly available in the event object
      // Instead, you can use a flag to prevent Lenis from handling the scroll
      lenis.stop()
      setTimeout(() => {
          lenis.start()
      }, 0)
    }
  });

  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf);

  // console.log('window.onload event fired');
  document.documentElement.classList.add('loaded');
  
  // Initialize all the things
  loadAllTheThings();
  childPages();
  mobileMenu();

  
};

document.addEventListener( 'wpcf7mailsent', function( event ) {
  setTimeout( () => {
      location = '/thank-you/';
  }, 0 ); // Wait for 3 seconds to redirect.
}, false );